import Http from '@/http';
import {
  TrackingClientType,
  TrackingEventType,
  TrackingPointStatus,
  TrackingTrackType,
} from '@/constants/business/tracking';
import {
  ITrackingActiveConfigReply,
  ITrackingCheckAccessReply,
  ITrackingDataDetailReply,
  ITrackingDataOverviewReply,
  ITrackingDataTrendReply,
  ITrackingGroupListReply,
  ITrackingGroupSaveReply,
  ITrackingPoint,
  ITrackingPointSaveReply,
  ITrackingPointSearchReply,
} from '@/api/typings/tracking';

export function apiTrackingCheckAccess() {
  return Http.post<Record<string, never>, ITrackingCheckAccessReply>(
    '/hr/tracking/check_access',
    {},
    {},
    { showError: false }
  );
}

interface ITrackingActiveConfigParams {
  clientType: TrackingClientType;
}

export function apiTrackingActiveConfig(params: ITrackingActiveConfigParams) {
  return Http.post<ITrackingActiveConfigParams, ITrackingActiveConfigReply>(
    '/hr/tracking/active_config',
    params,
    {},
    { showError: false }
  );
}

interface ITrackingPointSearchParams {
  page?: number;
  size?: number;
  name?: string;
  groupId?: number;
  pagePath?: string;
  trackType?: TrackingTrackType | 0;
  pointStatus?: TrackingPointStatus | 0;
  clientType?: TrackingClientType | 0;
}

export function apiTrackingPointSearch(params: ITrackingPointSearchParams) {
  return Http.post<ITrackingPointSearchParams, ITrackingPointSearchReply>(
    '/hr/tracking/point/search',
    params
  );
}

interface ITrackingPointSaveParams {
  info: ITrackingPoint;
}

export function apiTrackingPointSave(params: ITrackingPointSaveParams) {
  return Http.post<ITrackingPointSaveParams, ITrackingPointSaveReply>(
    '/hr/tracking/point/save',
    params
  );
}

interface ITrackingPointDeleteParams {
  id: number;
}

export function apiTrackingPointDelete(params: ITrackingPointDeleteParams) {
  return Http.post<ITrackingPointDeleteParams, void>(
    '/hr/tracking/point/delete',
    params
  );
}

interface ITrackingPointSetStatusParams {
  id: number;
  pointStatus: TrackingPointStatus.Published | TrackingPointStatus.Disabled;
}

export function apiTrackingPointSetStatus(
  params: ITrackingPointSetStatusParams
) {
  return Http.post<ITrackingPointSetStatusParams, void>(
    '/hr/tracking/point/set_status',
    params
  );
}

export function apiTrackingGroupList() {
  return Http.post<Record<string, never>, ITrackingGroupListReply>(
    '/hr/tracking/group/list',
    {}
  );
}

interface ITrackingGroupSaveParams {
  id?: number;
  name: string;
}

export function apiTrackingGroupSave(params: ITrackingGroupSaveParams) {
  return Http.post<ITrackingGroupSaveParams, ITrackingGroupSaveReply>(
    '/hr/tracking/group/save',
    params
  );
}

interface ITrackingGroupDeleteParams {
  id: number;
  migrateGroupId?: number;
}

export function apiTrackingGroupDelete(params: ITrackingGroupDeleteParams) {
  return Http.post<ITrackingGroupDeleteParams, void>(
    '/hr/tracking/group/delete',
    params
  );
}

interface ITrackingEventItem {
  pointId: number;
  eventType: TrackingEventType;
  eventTime?: number;
}

interface ITrackingEventReportParams {
  clientType: TrackingClientType;
  events: ITrackingEventItem[];
}

export function apiTrackingEventReport(params: ITrackingEventReportParams) {
  return Http.post<ITrackingEventReportParams, void>(
    '/hr/tracking/event/report',
    params,
    {},
    { showError: false }
  );
}

/** 看数筛选条件 */
interface ITrackingDataFilter {
  startTime?: number;
  endTime?: number;
  organizationIds?: string[];
  clientType?: TrackingClientType | 0;
  groupId?: number;
  pagePath?: string;
  name?: string;
}

export function apiTrackingDataOverview(params: {
  filter?: ITrackingDataFilter;
}) {
  return Http.post<
    { filter?: ITrackingDataFilter },
    ITrackingDataOverviewReply
  >('/hr/tracking/data/overview', params);
}

interface ITrackingDataDetailParams {
  filter?: ITrackingDataFilter;
  page?: number;
  size?: number;
}

export function apiTrackingDataDetail(params: ITrackingDataDetailParams) {
  return Http.post<ITrackingDataDetailParams, ITrackingDataDetailReply>(
    '/hr/tracking/data/detail',
    params
  );
}

interface ITrackingDataTrendParams {
  filter?: ITrackingDataFilter;
  pointId: number;
}

export function apiTrackingDataTrend(params: ITrackingDataTrendParams) {
  return Http.post<ITrackingDataTrendParams, ITrackingDataTrendReply>(
    '/hr/tracking/data/trend',
    params
  );
}

interface ITrackingDataExportParams {
  filter?: ITrackingDataFilter;
}

export function apiTrackingDataExport(params: ITrackingDataExportParams) {
  return Http.post<ITrackingDataExportParams, Blob>(
    '/hr/tracking/data/export',
    params,
    {
      responseType: 'blob',
    }
  );
}
